import React from 'react';
import Header from '../components/header/Header';
import Vacantes from '../components/vacantes/Vacantes';

function VacantesPage() {
  return (
    <div className="App">
      <Header />
      <Vacantes />
    </div>
  );
}

export default VacantesPage;
